module.exports = __webpack_public_path__ + "img/car-picture.f7c7f3e5.svg";